import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoalibaugcab() {



  const cardData = {




keyword: "Pune to Alibaug Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Alibaug Cab Service for families, couples, friends, corporate groups, and travelers planning a relaxing coastal getaway. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for one-way trips, round trips, and customized Alibaug sightseeing. With experienced drivers, clean and well-maintained cars, flexible pickup locations, spacious luggage facilities, transparent pricing, and 24/7 customer assistance, we make the journey from Pune to Alibaug convenient and enjoyable. Whether you are planning a beach holiday, weekend trip, family vacation, or coastal sightseeing tour, Garud Cab Service provides a safe and hassle-free travel experience.",

topPlaces: [
  {
    title: "Kashid Beach",
    description: "Kashid Beach is a beautiful coastal destination near Alibaug known for its soft white sand, clear waters, green surroundings, and peaceful atmosphere. It is a popular choice for families, couples, and friends looking for a relaxing beach getaway. Travelers booking a Pune to Alibaug cab can include Kashid in their itinerary for a refreshing coastal experience away from the busy city."
  },
  {
    title: "Korlai Fort",
    description: "Korlai Fort is a historic coastal fort located near the Arabian Sea and surrounded by scenic landscapes. The fort offers impressive views of the coastline, lighthouse area, and surrounding villages while showcasing the region's Portuguese-era heritage. It is an excellent destination for history enthusiasts, photographers, and travelers exploring Alibaug's lesser-known attractions."
  },
  {
    title: "Murud-Janjira Fort",
    description: "Murud-Janjira Fort is a remarkable sea fort located off the coast of Murud and is famous for its strong fortifications and maritime history. Reached by boat, the fort provides a memorable sightseeing experience with beautiful Arabian Sea surroundings. Travelers from Pune can use a private cab to comfortably reach the Murud area and plan the fort visit."
  },
  {
    title: "Kihim Beach",
    description: "Kihim Beach is a peaceful coastal destination near Alibaug surrounded by coconut trees, greenery, and natural landscapes. It is suitable for travelers looking for a quieter beach experience with opportunities for relaxing walks and photography. Families and couples can comfortably include Kihim Beach in a private Alibaug sightseeing itinerary."
  },
  {
    title: "Kanakeshwar Temple",
    description: "Kanakeshwar Temple is a beautiful hilltop religious destination near Alibaug surrounded by dense greenery and peaceful natural scenery. The temple is reached through a long series of steps and offers a combination of spirituality and nature. It is a suitable stop for devotees and travelers interested in exploring the cultural side of the Alibaug region."
  },
  {
    title: "Awas Beach",
    description: "Awas Beach is a calm and scenic beach destination near Alibaug known for its clean shoreline, greenery, and peaceful surroundings. It is less crowded than some of the region's popular beaches, making it ideal for families and couples seeking relaxation. A private cab allows visitors to explore Awas and other nearby coastal locations at their own pace."
  },
  {
    title: "Nagaon Beach",
    description: "Nagaon Beach is a popular Alibaug-area beach known for its wide sandy coastline, water activities, local food, and nearby holiday homes. It is a convenient destination for groups and families looking for a fun coastal outing. Travelers from Pune can enjoy flexible pickup and sightseeing arrangements with a dedicated outstation cab."
  },
  {
    title: "Revdanda Fort",
    description: "Revdanda Fort is a historic coastal fortification near Alibaug that reflects the area's Portuguese heritage. The old fort walls, sea views, and surrounding village atmosphere make it an interesting destination for heritage and photography enthusiasts. It can be conveniently combined with nearby beaches and coastal attractions during a private cab tour."
  },
  {
    title: "Alichibaug Beach",
    description: "Alibaug Beach is the main coastal attraction of the town and is known for its wide shoreline, sea views, evening atmosphere, and proximity to Kolaba Fort. Visitors can enjoy peaceful walks, local snacks, and views of the Arabian Sea. A private Pune to Alibaug cab makes it easy for families and groups to reach the beach comfortably."
  },
  {
    title: "Kolaba Fort",
    description: "Kolaba Fort is a historic sea fort situated close to Alibaug Beach and is one of the area's most recognizable heritage attractions. During suitable tidal conditions, visitors can access the fort and explore its walls, temples, and historic structures. Travelers can conveniently combine Kolaba Fort with Alibaug Beach and other nearby coastal destinations."
  }
],


"services": [
{
"name": "Pune to Alibaug Cab",
"description": "Book Pune to Alibaug Cab for comfortable, reliable, and convenient travel between Pune and Alibaug with professional chauffeurs and well-maintained AC vehicles. Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium cab options for family trips, beach holidays, weekend journeys, sightseeing, corporate outings, one-way drops, and round-trip travel."
},
{
"name": "Pune to Alibag Cab",
"description": "Reserve a Pune to Alibag Cab for a smooth and private journey with experienced drivers, clean interiors, spacious seating, and dependable door-to-door transportation. Vehicle options are available for individuals, families, tourists, corporate travelers, and groups planning beach trips, personal visits, weekend travel, sightseeing, one-way journeys, or return trips."
},
{
"name": "Pune to Alibaug Cab Booking",
"description": "Make Pune to Alibaug Cab Booking for a scheduled private journey with convenient pickup and direct drop facilities. Select your preferred travel date, pickup location, passenger capacity, luggage requirements, and vehicle category while enjoying professional chauffeur service and comfortable AC transportation for leisure, business, family, and tourist travel."
},
{
"name": "Pune to Alibaug Cab Charges",
"description": "Get information about Pune to Alibaug Cab Charges according to your selected vehicle, passenger requirements, and journey type. Choose from economical Sedan and Swift Dzire options or spacious Ertiga, Innova, Innova Crysta, Kia Carens, and SUV vehicles for comfortable one-way, round-trip, sightseeing, beach, family, and corporate journeys."
},
{
"name": "Pune to Alibaug Cab Fare",
"description": "Check Pune to Alibaug Cab Fare and select a vehicle according to your budget, group size, luggage requirements, and comfort preferences. Enjoy private chauffeur-driven AC transportation with flexible options suitable for beach holidays, weekend trips, sightseeing, family travel, corporate outings, personal visits, and outstation journeys."
},
{
"name": "Pune to Alibaug Cab One Way",
"description": "Book Pune to Alibaug Cab One Way for convenient point-to-point transportation without arranging a return journey. Enjoy direct pickup, professional chauffeur service, comfortable AC travel, and suitable vehicle options for individuals, families, tourists, corporate passengers, and travelers heading to Alibaug for beach holidays or personal requirements."
},
{
"name": "Pune to Alibaug Cab Price",
"description": "Find a competitive Pune to Alibaug Cab Price with multiple vehicle categories available for different travel requirements. Choose an economical sedan or spacious Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to passenger count, luggage, comfort expectations, and whether you require one-way, round-trip, sightseeing, or weekend transportation."
},
{
"name": "Pune to Alibaug Cab Service",
"description": "Choose Pune to Alibaug Cab Service for reliable door-to-door transportation with trained chauffeurs and well-maintained AC vehicles. The service is suitable for beach trips, family holidays, weekend travel, sightseeing, corporate outings, personal visits, and tourists looking for comfortable private transportation between Pune and Alibaug."
},
{
"name": "Pune to Alibaug Car Rental",
"description": "Hire Pune to Alibaug Car Rental with a professional chauffeur for convenient long-distance transportation without the stress of driving yourself. Select a comfortable sedan, spacious Ertiga, Innova, premium Innova Crysta, Kia Carens, or SUV according to your group size, luggage capacity, travel duration, and comfort requirements."
},
{
"name": "Pune to Alibaug Taxi",
"description": "Choose Pune to Alibaug Taxi for safe and comfortable road travel with courteous chauffeurs, air-conditioned vehicles, convenient pickup locations, and flexible journey options. The service is suitable for family trips, beach holidays, sightseeing, business travel, weekend getaways, personal visits, and passengers looking for private transportation to Alibaug."
},
{
"name": "Pune to Alibaug Round Trip",
"description": "Book Pune to Alibaug Round Trip for convenient return transportation when planning a beach holiday, family outing, weekend trip, sightseeing journey, or corporate visit. Enjoy comfortable AC vehicles, experienced chauffeurs, spacious luggage capacity, and flexible travel arrangements for traveling from Pune to Alibaug and returning according to your itinerary."
},
{
"name": "Pune to Alibaug Taxi Service",
"description": "Choose Pune to Alibaug Taxi Service for dependable chauffeur-driven transportation with clean AC vehicles, comfortable seating, convenient pickup, and direct destination drop. The service can be arranged for beach visits, family travel, weekend holidays, tourist sightseeing, corporate outings, personal appointments, and planned outstation journeys."
},
{
"name": "Pune to Nagaon Beach Cab",
"description": "Reserve Pune to Nagaon Beach Cab for a comfortable private journey from Pune to one of the popular beach destinations near Alibaug. Travel with professional chauffeurs in clean AC vehicles suitable for families, couples, groups, tourists, and weekend travelers planning a relaxing beach trip with convenient pickup and drop arrangements."
},
{
"name": "Pune to Alibaug Taxi",
"description": "Hire Pune to Alibaug Taxi for convenient private transportation with experienced chauffeurs, comfortable seating, air conditioning, and flexible pickup arrangements. The service is suitable for tourists, families, couples, corporate travelers, and groups traveling to Alibaug for beach holidays, sightseeing, weekend trips, and personal visits."
},
{
"name": "Pune to Alibaug Cab Service",
"description": "Book Pune to Alibaug Cab Service for comfortable intercity transportation with professional drivers and well-maintained AC vehicles. Select Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options for family trips, tourist journeys, beach holidays, corporate outings, one-way drops, and round-trip travel."
},
{
"name": "Pune to Alibaug Taxi Service",
"description": "Reserve Pune to Alibaug Taxi Service for reliable door-to-door travel with professional chauffeurs and convenient pickup from your home, office, hotel, or preferred location. Clean AC vehicles and flexible travel options make the service suitable for families, tourists, corporate groups, couples, and weekend travelers."
},
{
"name": "Cab from Pune to Alibaug",
"description": "Book a Cab from Pune to Alibaug for a private and comfortable road journey with convenient pickup and direct destination drop. Professional chauffeurs provide reliable transportation in AC vehicles suitable for families, tourists, couples, corporate travelers, and groups visiting Alibaug for beaches, sightseeing, holidays, or personal requirements."
},
{
"name": "Taxi from Pune to Alibaug",
"description": "Hire a Taxi from Pune to Alibaug for comfortable private transportation with experienced drivers and well-maintained air-conditioned vehicles. Flexible pickup and drop arrangements make the service suitable for beach holidays, weekend trips, sightseeing, family travel, corporate outings, personal visits, and tourist journeys."
},
{
"name": "Pune to Alibaug Outstation Cab",
"description": "Reserve Pune to Alibaug Outstation Cab for dependable long-distance transportation with professional chauffeurs and comfortable AC vehicles. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options for family holidays, beach trips, sightseeing, corporate outings, one-way transfers, and return journeys."
},
{
"name": "Pune to Alibaug Innova Cab",
"description": "Book Pune to Alibaug Innova Cab for a spacious and comfortable journey with ample seating, luggage capacity, AC interiors, and professional chauffeur service. Toyota Innova is suitable for families, small groups, corporate travelers, and tourists looking for additional comfort during a long-distance beach or sightseeing trip."
},
{
"name": "Pune to Alibaug Ertiga Cab",
"description": "Reserve Pune to Alibaug Ertiga Cab for practical and comfortable family transportation with spacious seating, useful luggage capacity, air conditioning, and an experienced chauffeur. Ertiga is a convenient option for small groups planning beach holidays, weekend trips, sightseeing, family outings, and one-way or round-trip journeys."
},
{
"name": "Pune to Alibaug Sedan Cab",
"description": "Choose Pune to Alibaug Sedan Cab for economical and comfortable private transportation with clean AC interiors, comfortable seating, and professional chauffeur service. Sedan vehicles are suitable for individuals, couples, small families, and business travelers planning beach trips, weekend travel, sightseeing, or direct one-way journeys."
},
{
"name": "Pune to Alibaug SUV Taxi",
"description": "Book Pune to Alibaug SUV Taxi for spacious and comfortable transportation suitable for families, groups, and passengers carrying additional luggage. Enjoy professional chauffeur service, air-conditioned interiors, convenient pickup, and reliable door-to-door travel for beach holidays, sightseeing, weekend getaways, corporate outings, and family trips."
},
{
"name": "Pune to Alibaug AC Cab",
"description": "Hire Pune to Alibaug AC Cab for a comfortable journey with climate-controlled interiors, spacious seating, professional chauffeurs, and convenient pickup and drop facilities. The service is suitable for individuals, families, tourists, corporate travelers, couples, and groups planning relaxed travel between Pune and Alibaug."
},
{
"name": "Pune to Alibaug Luxury Cab",
"description": "Reserve Pune to Alibaug Luxury Cab for a premium and relaxed travel experience with spacious interiors, comfortable seating, air conditioning, and professional chauffeur service. Premium vehicles are suitable for corporate executives, families, special occasions, weekend holidays, beach trips, and passengers seeking enhanced comfort."
},
{
"name": "Pune to Alibaug Beach Cab",
"description": "Book Pune to Alibaug Beach Cab for convenient transportation to popular beach destinations and coastal attractions around Alibaug. Travel comfortably with professional chauffeurs and clean AC vehicles suitable for families, couples, groups, and tourists planning beach holidays, weekend trips, sightseeing, and relaxing coastal getaways."
},
{
"name": "Pune to Alibaug Weekend Trip Cab",
"description": "Reserve Pune to Alibaug Weekend Trip Cab for a comfortable getaway from Pune with flexible pickup and travel arrangements. Enjoy private AC transportation for families, couples, friends, and groups visiting beaches, coastal attractions, local sightseeing spots, and nearby destinations during weekend holidays."
},
{
"name": "Pune to Alibaug Sightseeing Taxi",
"description": "Book Pune to Alibaug Sightseeing Taxi for convenient local travel and exploration of beaches, forts, temples, coastal attractions, and popular tourist places around Alibaug. Professional chauffeurs provide comfortable transportation with flexible travel schedules and suitable vehicle options for families, groups, couples, and tourists."
},
{
"name": "Pune to Alibaug Family Trip Cab",
"description": "Choose Pune to Alibaug Family Trip Cab for comfortable and convenient transportation during family holidays and weekend getaways. Spacious AC vehicles, experienced chauffeurs, flexible pickup, luggage-friendly interiors, and multiple car categories make the service suitable for families traveling with children, seniors, and additional luggage."
},
{
"name": "Pune to Alibaug Corporate Outing Taxi",
"description": "Arrange Pune to Alibaug Corporate Outing Taxi for comfortable group transportation during company trips, team outings, employee travel, and business leisure programs. Choose suitable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, or larger vehicle options according to group size and travel requirements."
},
{
"name": "Pune to Alibaug Taxi Booking Online",
"description": "Use Pune to Alibaug Taxi Booking Online to conveniently arrange your private journey before the scheduled travel date. Select your pickup location, travel timing, passenger capacity, luggage requirements, and preferred vehicle while enjoying professional chauffeur service, clean AC interiors, and flexible one-way or round-trip travel arrangements."
},
{
"name": "Pune to Alibaug Taxi Fare",
"description": "Get Pune to Alibaug Taxi Fare details with flexible vehicle categories for different budgets and passenger requirements. Choose an economical Sedan or upgrade to Ertiga, Innova, Innova Crysta, Kia Carens, or SUV for additional space and comfort while traveling with experienced chauffeurs and convenient pickup and drop arrangements."
},
{
"name": "Best Pune to Alibaug Cab Service",
"description": "Book the Best Pune to Alibaug Cab Service for dependable and comfortable intercity transportation with experienced chauffeurs, clean AC vehicles, convenient pickup, and flexible booking options. Vehicle choices are available for families, tourists, couples, corporate travelers, groups, beach holidays, sightseeing trips, weekend journeys, and one-way or round-trip travel."
},
{
"name": "Cheap Pune to Alibaug Cab",
"description": "Choose a Cheap Pune to Alibaug Cab for budget-friendly travel while maintaining essential comfort and convenience. Affordable vehicle options, professional chauffeurs, air-conditioned interiors, direct pickup, and flexible one-way or round-trip arrangements make the service suitable for students, individuals, families, tourists, couples, and weekend travelers."
}
],
"tableData": [
["Pune to Alibaug Cab", "Pune to Alibag Cab"],
["Pune to Alibaug Cab Booking", "Pune to Alibaug Cab Charges"],
["Pune to Alibaug Cab Fare", "Pune to Alibaug Cab One Way"],
["Pune to Alibaug Cab Price", "Pune to Alibaug Cab Service"],
["Pune to Alibaug Car Rental", "Pune to Alibaug Taxi"],
["Pune to Alibaug Round Trip", "Pune to Alibaug Taxi Service"],
["Pune to Nagaon Beach Cab", "Pune to Alibaug Outstation Cab"],
["Pune to Alibaug Innova Cab", "Pune to Alibaug Ertiga Cab"],
["Pune to Alibaug Sedan Cab", "Pune to Alibaug SUV Taxi"],
["Pune to Alibaug AC Cab", "Pune to Alibaug Luxury Cab"],
["Pune to Alibaug Beach Cab", "Pune to Alibaug Weekend Trip Cab"],
["Pune to Alibaug Sightseeing Taxi", "Pune to Alibaug Family Trip Cab"],
["Pune to Alibaug Corporate Outing Taxi", "Pune to Alibaug Taxi Booking Online"],
["Pune to Alibaug Taxi Fare", "Best Pune to Alibaug Cab Service"],
["Cheap Pune to Alibaug Cab", "Pune to Alibaug Cab Booking"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Alibaug Cab for a Coastal Getaway",
    WhyChoosedescription: "Garud Cab Service provides comfortable Pune to Alibaug cab services for beach holidays, family outings, weekend breaks, couple trips, and relaxed coastal travel with convenient private transportation."
  },
  {
    WhyChooseheading: "Convenient Doorstep Pickup in Pune",
    WhyChoosedescription: "Begin your Alibaug journey from a convenient location in Pune. Pickup can be arranged from your home, hotel, office, residential society, or another preferred point."
  },
  {
    WhyChooseheading: "A Practical Choice for Weekend Plans",
    WhyChoosedescription: "Alibaug is popular for short breaks from Pune, and a private cab allows you to leave at a time that suits your group instead of coordinating your trip around fixed public transport schedules."
  },
  {
    WhyChooseheading: "One-Way Drops and Return Trips",
    WhyChoosedescription: "Select a one-way cab if you only need transportation to Alibaug, or arrange a return journey when your plan includes coming back to Pune after your beach holiday or sightseeing."
  },
  {
    WhyChooseheading: "Comfortable Travel for Families & Friends",
    WhyChoosedescription: "Garud Cab Service can arrange a suitable vehicle based on the number of passengers, luggage, and comfort preferences, making it convenient for families, couples, and groups of friends."
  },
  {
    WhyChooseheading: "Alibaug Sightseeing by Private Cab",
    WhyChoosedescription: "Make your trip more flexible by visiting popular attractions such as Alibaug Beach, Kolaba Fort, Kihim Beach, Nagaon Beach, Kashid Beach, and other nearby coastal locations."
  },
  {
    WhyChooseheading: "Ideal for Resorts, Beach Holidays & Events",
    WhyChoosedescription: "The cab service is useful for travellers heading to Alibaug resorts, family celebrations, corporate outings, weekend stays, destination events, and personal vacations."
  },
  {
    WhyChooseheading: "Plan Your Alibaug Journey with Garud",
    WhyChoosedescription: "Share your Pune pickup point, travel date, passenger count, luggage requirement, preferred vehicle, and one-way or return plan to arrange your Pune to Alibaug cab."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Alibaug Cab Service?",
    answer: "Yes, Garud Cab Service provides Pune to Alibaug cabs for one-way travel, return trips, weekend holidays, family outings, sightseeing, and resort transfers."
  },
  {
    question: "Can I book a one-way cab from Pune to Alibaug?",
    answer: "Yes, one-way cab service is available for passengers who need direct transportation from Pune to Alibaug."
  },
  {
    question: "Can I book a return cab from Alibaug to Pune?",
    answer: "Yes, return and round-trip cab arrangements can be planned according to your holiday schedule and preferred departure time."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from homes, hotels, offices, residential societies, and other convenient locations in Pune."
  },
  {
    question: "Which vehicles are available for Pune to Alibaug travel?",
    answer: "Suitable vehicle options can be arranged according to the number of passengers, luggage, comfort requirements, and vehicle availability."
  },
  {
    question: "Is the cab suitable for family beach trips?",
    answer: "Yes, families can book a suitable private vehicle according to their group size, luggage, and overall travel requirements."
  },
  {
    question: "Can I include Alibaug sightseeing in the cab trip?",
    answer: "Yes, sightseeing can be included in your travel plan with places such as Alibaug Beach, Kolaba Fort, Kihim Beach, Nagaon Beach, Kashid Beach, and other nearby attractions."
  },
  {
    question: "Can I book a cab for an Alibaug resort?",
    answer: "Yes, private cab transportation can be arranged for passengers travelling from Pune to resorts, hotels, villas, and other accommodation locations in and around Alibaug."
  },
  {
    question: "Is Pune to Alibaug cab service suitable for a weekend getaway?",
    answer: "Yes, a private cab is a convenient option for short weekend holidays, beach trips, couple getaways, and family vacations."
  },
  {
    question: "How can I book a Pune to Alibaug Cab?",
    answer: "Provide your Pune pickup location, travel date, passenger details, preferred vehicle, and one-way or return requirement to arrange your Alibaug cab with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Yash Thakur",
    feedback: "We booked a Pune to Alibaug cab for a weekend beach trip with friends. The pickup was easy to coordinate and the private vehicle made the journey comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neelam Joshi",
    feedback: "Our family travelled to Alibaug for a short holiday and stayed at a resort. The cab was convenient for our luggage and made the journey from Pune much easier.",
    rating: 5
  }
];











  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Alibaug Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-alibaug-cab.webp",
  "description": "Book a reliable Pune to Alibaug Cab with Garud Cab for safe, comfortable, and convenient travel. Choose one way, round trip, taxi, and car rental services from Pune to Alibaug with Sedan, Ertiga, SUV, Innova, and Innova Crysta options for family trips, weekend getaways, sightseeing, and business travel.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-alibaug-cab"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune to Alibaug Cab | One Way, Round Trip & Taxi Fare | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Alibaug Cab with Garud Cab for comfortable and reliable travel. Get one way, round trip, taxi, car rental, and cab booking services with competitive fares and multiple vehicle options."
  />

  <meta
    name="keywords"
    content="Pune to Alibaug cab, Pune to Alibag cab, Pune to Alibaug cab booking, Pune to Alibaug cab charges, Pune to Alibaug cab fare, Pune to Alibaug cab one way, Pune to Alibaug cab price, Pune to Alibaug cab service, Pune to Alibaug car rental, Pune to Alibaug taxi, Pune to Alibaug round trip"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoalibaugcab;